import { render } from "./ExIcon.vue?vue&type=template&id=b310c1f4&scoped=true"
import script from "./ExIcon.vue?vue&type=script&lang=js"
export * from "./ExIcon.vue?vue&type=script&lang=js"

import "./ExIcon.vue?vue&type=style&index=0&id=b310c1f4&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b310c1f4"]])

export default __exports__